import React, { FC } from 'react'
import { useHistory } from 'react-router-dom'
import { Button } from 'transfix-ui/components/Button'
import { Box, Typography } from 'transfix-ui/core'
import { ResponsiveLayout } from 'apps/fleet-planner/components/layout/ResponsiveLayout'
import { useFMSAnalytics } from 'apps/fleet-planner/hooks'

interface IAccountDeletionWarningPage {
  /**
   * A function provided by the parent component to navigate to the default page
   */
  onGoToDefaultRoute: () => void
}

export const AccountDeletionWarningPage: FC<IAccountDeletionWarningPage> = ({
  onGoToDefaultRoute,
}) => {
  const history = useHistory()
  const { trackEvent } = useFMSAnalytics()

  const pressBackButtonHandler = () => {
    onGoToDefaultRoute()
  }

  const clickHandler = () => {
    trackEvent('Settings', 'DELETE_USER_ACCOUNT_SETTINGS')
    history.push('/account-deletion/step/welcome')
  }

  return (
    <ResponsiveLayout title='Account Deletion' onPressBackButton={pressBackButtonHandler}>
      <Box mx={3}>
        <Box pb={1}>
          <Typography variant='h3'>Delete Your Account</Typography>
        </Box>
        <Typography variant='body2'>
          Deleting your account is permanent and will result in you no longer being able to login
          and access any of your data including load history, documents, and invoices. Only users
          who have no loads in progress or docs needed on delivered loads are eligible to delete
          their accounts.
        </Typography>
        <Box display='flex' justifyContent='flex-end' pt={2}>
          <Button
            data-test='submit-time-format'
            type='submit'
            color='hotPrimary'
            size='small'
            width='40%'
            onClick={clickHandler}>
            Delete Account
          </Button>
        </Box>
      </Box>
    </ResponsiveLayout>
  )
}
